import { Component, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { Store } from '@ngrx/store';
import { mobileNavigation } from 'src/app/store/navigation';
import { APP_CONFIG } from 'src/app/app.config';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'smart-main',
  templateUrl: './main.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainComponent {

  app = APP_CONFIG.app;

  constructor(
    private store: Store<any>,
    private sanitizer: DomSanitizer  
  ) { }

  closeMobileNav($event: MouseEvent) {
    $event.preventDefault();
    this.store.dispatch(mobileNavigation({open: false}));
  }

  styles = (sessionStorage.getItem('styles')) ? JSON.parse(sessionStorage.getItem('styles')) : {}
  
  @HostBinding('style.--primary-color-bg') get primaryColor() {
    return `${this.styles.primary_color_bg}`;
  }

  @HostBinding('style.--primary-color-text') get primaryTextColor() {
    return `${this.styles.primary_color_text}`;
  }

  @HostBinding('style.--normal-color-text') get normalTextColor() {
    return `${this.styles.normal_color_text}`;
  }

  @HostBinding('style.--table-color-bg') get tableColor() {
    return `${this.styles.table_color_bg}`;
  }

  @HostBinding('style.--table-color-text') get tableTextColor() {
    return `${this.styles.table_color_text}`;
  }

  @HostBinding('style.--progress-color-bg') get progressColor(): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(`${this.styles.progress_color_bg}`);
  }

  @HostBinding('style.--header-color-bg') get headerColor(): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(this.styles.header_color_bg);
  }

  @HostBinding('style.--tab-color-text') get tabTextColor() {
    return `${this.styles.tab_color_text}`;
  }

  @HostBinding('style.--tab-act-color-text') get tabActTextColor() {
    return `${this.styles.tab_act_color_text}`;
  }

  @HostBinding('style.--toggle-color-bg') get toggleColor() {
    return `${this.styles.toggle_color_bg}`;
  }

  @HostBinding('style.--toggle-color-text') get toggleTextColor() {
    return `${this.styles.toggle_color_text}`;
  }

  @HostBinding('style.--menu-color-bg') get menuColor() {
    return `${this.styles.menu_color_bg}`;
  }

  @HostBinding('style.--menu-color-text') get menuTextColor() {
    return `${this.styles.menu_color_text}`;
  }

  @HostBinding('style.--menu-sub-color-bg') get menuSubColor() {
    return `${this.styles.menu_sub_color_bg}`;
  }

  @HostBinding('style.--menu-sub-color-text') get menuSubTextColor() {
    return `${this.styles.menu_sub_color_text}`;
  }

  @HostBinding('style.--menu-hover-color-bg') get menuHoverColor() {
    return `${this.styles.menu_hover_color_bg}`;
  }

  @HostBinding('style.--menu-hover-color-text') get menuHoverTextColor() {
    return `${this.styles.menu_hover_color_text}`;
  }
}
